import '../../../components/CongratsPage/CongratsPage.css'
import './components.css'

import React from "react";
import {useTranslation} from "react-i18next";

export function BackgroundImage() {
    return <>
        <div className={"congrats-bg-img"}/>
    </>
}

export function CongratsLower() {
    const {t} = useTranslation();
    return <>
        <span>{t("congratsAntennaGRLower")}</span>
        <button className={"congrats-button"} onClick={()=>{
            window.location.assign("/PickProgram")
        }}>{t("congratsAntennaGRLowerBtn")}</button>
    </>
}

export function CongratsUpper() {
    const {t} = useTranslation();
    return <>
        <div className={"idp-congrats-container"}>
            <span>{t("congratsAntennaGRUpper")}</span>
        </div>
    </>
}